// AVAILABLE_TAGS lists the tags that can be assigned to a settings branch.
// Reused across casino and provider configuration pages.
export const AVAILABLE_TAGS = ['GATS', 'DEV']